import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ProductsState } from './products.state';

// Selector para el feature state 'products'
export const selectProductsState = createFeatureSelector<ProductsState>('products');

// Selectores para partes específicas del estado
export const selectAllProducts = createSelector(
  selectProductsState,
  (state) => state.products
);

export const selectTotalProducts = createSelector(
  selectProductsState,
  (state) => state.totalElements
);

export const selectProductsLoading = createSelector(
  selectProductsState,
  (state) => state.loading
);

export const selectProductsError = createSelector(
  selectProductsState,
  (state) => state.error
);
